<!-- Desktop View -->
<div class="d-none d-lg-block" *ngIf="isMobile">
  <div *ngIf="tenders; else skeletonLoader"
    [ngClass]="{'with-scroll-container': isScroll, 'without-scroll-container': !isScroll}">
    <div [id]="containerId" id="{{containerId}}" class="inner-container" (scroll)="onSliderScroll($event)"
      [class.top-performing-inner-container]="topPerformingContainer">
      <ng-container *ngFor="let item of tenders; let index=index; trackBy: trackById ">

        <div class="card card-9 card-custom-1 text-start mb-4 card-1-min-height mr-10">
          <a (click)="navigateToTendersImg(item.link, $event)"
            class="card-header border-0 d-flex justify-content-between align-items-start pb-0">

            <img *ngIf="type !== 'Keywords'" width="268" height="145"
              [lazyLoad]="item.link ? imageBasePath + item.link + '.webp' : imageBasePath + 'banner/default.webp'"
              [alt]="item?.name" (error)="handleImageError($event)" class="category-img" loading="lazy">

            <img *ngIf="type === 'Keywords'"
              [src]="item.link ? imageBasePath + item.link + '.webp' : imageBasePath + 'banner/default.webp'"
              [alt]="item?.name" (error)="handleImageError($event)" class="category-img" loading="lazy">
          </a>
          <div class="card-body py-0">
            <div class="list-group-horizontal">
              <a class="cursor mb-" (click)="navigateToTenders(item.link); $event.preventDefault()"
                [href]="baseUrl + '/' + item.link + '-tenders/active'">
                <h3 class="mb-0 heading-min-height">{{item?.name}} Tenders</h3>
              </a>
              <div class="d-flex justify-content-between align-items-center">
                <!-- <p class="mb-0">{{item?.count}} Tenders</p> -->
                <p class="mb-0">{{item?.count | numberFormatter}} Tenders</p>
                <a (click)="navigateToTenders(item.link); $event.preventDefault()"
                  [href]="baseUrl + '/' + item.link + '-tenders/active'"
                  class="btn btn-outline-danger card-view-more">View
                  More </a>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <span class="left-arrow arrow" *ngIf="isLeftVisible" (click)="scrollSliderDiv(false)"
        [class.hide-arrow-div]="hideContainer">
        <i class="sprite-img icon-back "></i>
      </span>
      <span class="right-arrow arrow" *ngIf="isRightVisible" (click)="scrollSliderDiv(true)"
        [class.hide-arrow-div]="hideContainer">
        <i class="sprite-img icon-next cursor "></i>
      </span>
    </div>
  </div>
  <ng-template #skeletonLoader>
    <div class="d-flex overflow-scroll">
      <div *ngFor="let _ of [1,2,3,4,5,6]">
        <skeleton-loader></skeleton-loader>
      </div>
    </div>
  </ng-template>
</div>

<!-- Mobile View -->
<div class="d-block d-lg-none">
  <div class="mobile-card-overflow" *ngIf="tenders">
    <div class=" mobile-card-row inner-container" *ngFor="let row of cardRows; trackBy: trackByIndex">
      <div class="mobile-slider-width" *ngFor="let item of row; let index=index; trackBy: trackById">
        <div class="card card-9 card-custom-1 mobile-card-width text-start mb-4 card-1-min-height mx-0">
          <a (click)="navigateToTenders(item.link); $event.preventDefault()"
            class="card-header border-0 d-flex justify-content-between align-items-start pb-0"
            [href]="baseUrl + '/' + item.link + '-tenders/active'">

            <img width="128" height="145" *ngIf="type !== 'Keywords'"
              [ngClass]="{'object-fit-contain': type == 'Authority'}"
              [lazyLoad]="item.link ? imageBasePath + item.link + '.webp' : imageBasePath + 'banner/default.webp'"
              [alt]="item?.name" (error)="handleImageError($event)" class="category-img" loading="lazy">

            <img width="128" height="145" *ngIf="type === 'Keywords'"
              [src]="item.link ? imageBasePath + item.link + '.webp' : imageBasePath + 'banner/default.webp'"
              [alt]="item?.name" (error)="handleImageError($event)" class="category-img">

          </a>
          <div class="card-body py-0">
            <div class="list-group-horizontal">
              <a (click)="navigateToTenders(item.link); $event.preventDefault()" class="cursor mb-"
                [href]="baseUrl + '/' + item.link + '-tenders/active'">
                <h3 class="mb-0 heading-min-height">{{item?.name}} Tenders</h3>
              </a>
              <div class="d-flex justify-content-between align-items-center card-content">
                <p class="mb-0">{{item?.count | numberFormatter}} Tenders</p>
                <a (click)="navigateToTenders(item.link); $event.preventDefault()"
                  [href]="baseUrl + '/' + item.link + '-tenders/active'"
                  class="btn btn-outline-danger card-view-more">View
                  More <i class="arrow-right-red-2 sprite-img d-block d-lg-none"></i> </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>